import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  Actions,
  createEffect,
  ofType
} from "@ngrx/effects";
import {
  Action,
  Store
} from "@ngrx/store";
import {
  of
} from "rxjs";
import {
  catchError,
  exhaustMap,
  map,
  mergeMap,
  tap
} from "rxjs/operators";
import {
  CorporateInformationResponseModel
} from "../../domain";
import { CorporateService } from "../../service/corporate.service";
import * as CorporateInfoAction from "./corporate-info.action";
import { CorporateInfoActionTypes } from "./corporate-info.action";

@Injectable()
export class CorporateInfoEffect {

  getCorporateInfo$ = createEffect(() => this.actions$.pipe(
    ofType<CorporateInfoAction.GetCorporateInfo>(CorporateInfoActionTypes.GetCorporateInfo),
    exhaustMap(() =>
      this.corporateService.getCorporateInfo().pipe(
        map((data: CorporateInformationResponseModel) => new CorporateInfoAction.CorporateInfoSuccess(data)),
        catchError((err: HttpErrorResponse) => of(new CorporateInfoAction.CorporateInfoFault(err.message)))
      )
    )
  )
  );

  constructor(private actions$: Actions, private store$: Store<any>, private corporateService: CorporateService) {
  }
}
